import { Tabs } from './Tabs'
import { withTabs } from './withTabs'

const ConnectedTabs = withTabs(Tabs)

export { ConnectedTabs as Tabs }
